<script>
import { Bar, mixins } from 'vue-chartjs'
import './ChartBarCustom'

export default {
  extends: Bar,
  mixins: [
    mixins.reactiveProp
  ],
  data () {
    const self = this
    return {
      colors: ['#48E264', '#BE2D2F'],
      // colorsHover: ['#004FE2'],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        hover: {
          mode: 'index',
          intersect: true
        },
        legend: {
          display: false
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          backgroundColor: '#FFFFFF',
          titleFontColor: '#63627C',
          titleFontSize: 13,
          bodyFontColor: '#63627C',
          callbacks: {
            label: function (tooltipItem, data) {
              return self.$fmt.integer(tooltipItem.yLabel)
            }
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: true,
              color: '#CFD8DC'
            },
            ticks: {
              fontColor: this.$vuetify.theme.dark ? '#E6E9F0' : '#8B94A9',
              fontSize: 14,
              maxTicksLimit: 10,
              min: 0,
              beginAtZero: true,
              callback: function (value, index, values) {
                return self.$fmt.integer(value)
              }
            }
          }],
          xAxes: [{
            barPercentage: 1,
            gridLines: {
              display: false,
              color: '#D8E0EA'
            }
          }]
        }
      }
    }
  },
  mounted () {
    this.drawChart()
  },
  watch: {
    chartData () {
      this.drawChart()
    }
  },
  methods: {
    drawDatasets () {
      this.chartData.datasets.forEach((dataset, i) => {
        if (dataset.type !== 'line') {
          this.chartData.datasets[i] = Object.assign({}, this.chartData.datasets[i], {
            backgroundColor: dataset.backgroundColor || this.colors[i],
            hoverBackgroundColor: dataset.hoverBackgroundColor || this.colors[i],
            borderWidth: 0,
            borderColor: '#FFFFFF',
            hoverBorderColor: '#FFFFFF',
            barThickness: 18
          })
        }
      })
    },
    drawChart () {
      if (this.chartData.datasets.length > 1 && this.options.scales.yAxes.length === 1) {
        this.options.scales.yAxes.push({
          id: 'right-y-axis',
          type: 'linear',
          position: 'right',
          ticks: {
            fontColor: this.$vuetify.theme.dark ? '#E6E9F0' : '#8B94A9',
            fontSize: 14,
            maxTicksLimit: 10,
            min: 0,
            beginAtZero: true,
            callback: (value, index, values) => {
              return this.$fmt.integer(value)
            }
          },
          gridLines: {
            display: false
          }
        })
      } else if (this.chartData.datasets.length <= 1 && this.options.scales.yAxes.length > 1) {
        this.options.scales.yAxes.pop()
      }
      this.drawDatasets()
      this.renderChart(this.chartData, this.options)
      this.$emit('legend', this.$data._chart.generateLegend())
    }
  }
}
</script>
